var _rect, _rect2, _rect3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 30,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -259,
    y: -746,
    width: 1867,
    height: 1242,
    stroke: "black",
    strokeWidth: 30
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 29,
    rx: 4.5,
    fill: "white",
    stroke: "#9876A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7742 11.0014C11.0422 10.9998 11.8387 10.9281 12.1761 12.0668C12.4034 12.8338 12.7654 14.0903 13.2622 15.8361H13.4646C13.9973 13.9955 14.3633 12.7391 14.5625 12.0668C14.9034 10.9162 15.7557 11.0014 16.0966 11.0014L18.7268 11.0014V19.1832H16.046V14.3616H15.8663L14.3719 19.1832H12.3549L10.8605 14.358H10.6808V19.1832H8V11.0014L10.7742 11.0014ZM22.5763 11.0014V15.8267H22.7902L24.608 11.8589C24.9608 11.0693 25.7129 11.0014 25.7129 11.0014H28.3071V19.1832H25.5703V14.358H25.3565L23.5743 18.3258C23.2215 19.1118 22.4337 19.1832 22.4337 19.1832H19.8396V11.0014H22.5763ZM37.7665 14.8895C37.3848 15.9713 36.1859 16.746 34.8586 16.746H31.9886V19.1832H29.3861V14.8895H37.7665Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9843 11.001H29.2498C29.3862 12.8225 30.9549 14.3819 32.5788 14.3819H37.9475C38.2573 12.868 37.1907 11.001 34.9843 11.001Z",
    fill: "url(#1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 1,
    x1: 38.0001,
    y1: 13.1277,
    x2: 29.2498,
    y2: 13.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.3ff70cd59c24054399d35883dfc7f32c.svg";
export { ForwardRef as ReactComponent };